export type GeolocationCoordinates = {
  longitude: number
  latitude: number
}

class Geolocation {
  public readonly isSupportedByDevice: boolean
  public readonly coordinates?: GeolocationCoordinates
  public readonly authorized?: boolean

  constructor({ isSupportedByDevice, coordinates, authorized }: Geolocation) {
    this.isSupportedByDevice = isSupportedByDevice
    this.coordinates = coordinates
    this.authorized = authorized
  }
}

export default Geolocation
